<template>
	<div :class="[ 'widget', value.settings.type ]" :style="{ opacity: edit || value.settings.type != 'empty' ? '1' : '0' }">
		<div v-show="!edit" class="body">
			<slot />
		</div>
		<div v-show="edit" class="filters" style="position: relative; height: 100%;">
			<div class="head">
				<select @change="select($event)"><option :selected="t.name == value.settings.type" v-for="(t, i) in types" :key="i" :value="i">{{ t.label }}</option></select>
			</div>
			<div class="body" style="overflow-y: auto; position: absolute; top: 64px; left: 0; right: 0; bottom: 0;">
				<div class="filter" v-for="(f, i) in _filters" :key="i">
					<div class="label">{{ f.label }}</div>
					<div class="input">
						<select v-model="value.filters[f.name]">
							<option v-if="!f.required" :value="null">Alle</option>
							<option v-for="(o, j) in f.options" :key="j" :value="o.value">{{ o.label }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { bus } from '../../bus'

	export default {
		props: {
			value: {
				type: Object
			},
			types: {
				type: Array
			},
			edit: {
				type: Boolean
			}
		},
		computed: {
			_filters() {
				var self = this;
				var type = this.types.find(function (item) { return item.name == self.value.settings.type; });
				return type ? type.filters : [];
			}
		},
		watch: {
			edit() {
				this.update();
			}
		},
		methods: {
			select(e) {
				var type = this.types[e.target.value];

				

				var value = {
					settings: {
						type: 	type.name,
						label: 	type.label,
						is: 	type.is
					},
					filters: {},
					props: type.props
				};

				for (var i = 0; i < type.filters.length; ++i) {
					value.filters[type.filters[i].name] = null;
				}

				this.$emit('input', value);
				this.update();
			},
			update() {
				var self = this;

				this.axios
					.get('/widgets/data/?type=' + self.value.settings.type + '&filters=' + encodeURI(JSON.stringify(self.value.filters)))
					.then(function (r) {
						var value = Object.assign({}, self.value);
						value.data 	= r.data.data;
						value.props = r.data.props;
						self.$emit('input', value);
					});
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});
		}
	}
</script>

<style lang="scss" scoped>
	.widget {
		background-color: white;
		box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
		transition: 0.3s;
		border-radius: 5px;

		&.empty {
			background-color: #F0F0F0;
		}

		& > .body {
			height: 100%;
			overflow: hidden;
			position: relative;
		}

		& > .filters {
			& > .head {
				padding: 20px;

				& > select {
					width: 100%;
					font-size: 18px;
					background-color: transparent;
				}
			}

			& > .body {
				border-top: 1px solid #cecece;

				& > .filter {
					display: grid;
					grid-template-columns: 1fr 3fr;
					border-top: 1px solid #f0f0f0;

					&:first-child {
						border-top: none;
					}

					& > .label {
						padding: 0 20px 0 20px;
						line-height: 40px;
						font-size: 14px;
						font-weight: bold;
					}

					& > .input {
						padding-right: 20px;

						& > select {
							width: 100%;
							height: 40px;
							font-size: 14px;
						}
					}
				}
			}
		}
	}
</style>